import { API_ENDPOINT } from './config';

export const urlsDissertations = {
  // Dissertations
  dissertations: `${API_ENDPOINT}/dissertations`,
  dissertationDetail: (id) => `${API_ENDPOINT}/dissertations/${id}`,
};

export const routesDissertations = {
  // Public
  dissertationsDetail: '/dizertacne-prace',

  // CMS
  cmsDissertation: '/cms/dissertations',
  cmsDissertationEdit: '/cms/dissertations/edit',
  cmsDissertationCreate: '/cms/dissertations/create',
}
